import { useContext } from 'react'

import AppContext from '@/context/AppContext'
import { updateAddressField } from '@/helpers'

import { replaceShippingAddress } from '../helpers'

const useAddressForm = () => {
  const { context, setContext } = useContext(AppContext)

  const updateAddress = e => {
    const { name, value } = e.target

    setContext(context => {
      const currentAddress = context.orderInfo.shipping_address

      return {
        ...context,
        orderInfo: {
          ...context.orderInfo,
          shipping_address: updateAddressField(currentAddress, name, value),
        },
      }
    })
  }

  const replaceAddress = address => {
    setContext(context => ({ ...context, orderInfo: replaceShippingAddress(context.orderInfo, address) }))

    return replaceShippingAddress(context.orderInfo, address)
  }

  const handleChangeUseSameAddress = () => {
    setContext(context => ({
      ...context,
      orderInfo: {
        ...context.orderInfo,
        use_same_address_for_exchange: !context.orderInfo.use_same_address_for_exchange,
      },
    }))
  }

  return {
    updateAddress,
    replaceAddress,
    handleChangeUseSameAddress,
    shippingAddress: context?.orderInfo?.shipping_address,
    provinces: context?.allowed_region?.provinces?.map(p => ({ value: p.code, label: p.name })) || [],
  }
}

export default useAddressForm
